import { render, staticRenderFns } from "./PayDialog.vue?vue&type=template&id=947be746&scoped=true&"
import script from "./PayDialog.vue?vue&type=script&lang=js&"
export * from "./PayDialog.vue?vue&type=script&lang=js&"
import style0 from "./PayDialog.vue?vue&type=style&index=0&id=947be746&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "947be746",
  null
  
)

export default component.exports